import React, { useCallback } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { PapiUser } from '@wix/da-papi-types';
import { useVerification } from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../EmptyState';

import s from './EmptyState.scss';

export type Props = {
  isOwner: boolean;
  profileOwnerUser: PapiUser;
};

const TierContentEmptyState: React.FC<Props> = ({
  profileOwnerUser,
  isOwner,
}) => {
  const { t } = useTranslation();
  const { restrictToVerified } = useVerification();
  const { username } = profileOwnerUser;
  const contactUser = useCallback(() => {
    restrictToVerified('notes', () =>
      window.location.assign(Url.userNoteLink(username))
    )();
  }, [username, restrictToVerified]);

  return isOwner ? (
    <EmptyState
      view="small"
      className={classnames(s['empty-state'], s['is-owner'])}
      title={t(`widgets.tierContent.empty.title.owner`)}
      subtitle={t(`widgets.tierContent.empty.subtitle.owner`)}
    />
  ) : (
    <EmptyState
      view="small"
      className={s['empty-state']}
      titleClassName={'empty-state-title'}
      title={t(`widgets.tierContent.empty.title.visitor`, {
        username,
      })}
      subtitle={t(`widgets.tierContent.empty.subtitle.visitor`, {
        username,
      })}
      buttonLabel={t(`widgets.tierContent.empty.CTALabel.visitor`)}
      withButton={true}
      onButtonClick={contactUser}
    />
  );
};

TierContentEmptyState.displayName = 'TierContentEmptyState';

export default TierContentEmptyState;
